import React from "react";

import { Button } from "@blueprintjs/core";
import { ButtonVariant } from "common/views/button/Button.view";
import { IDataTableColumn } from "common/views/table/DataTable";
import { IconNames } from "@blueprintjs/icons";
import MutationButton from "common/views/button/MutationButton";
import { MutationType } from "typegraph";
import Icon from "common/views/icon/Icon";
import { FavoritePlaylist } from "../entities/FavoritePlaylist";
import UrlUtil from "core/util/UrlUtil";

export const name: IDataTableColumn<FavoritePlaylist, any> = {
	name: "name",
	sort: "name",
	label: { k: "col.title", v: "Title" },
	component: playlist => {
		if (!playlist.name) {
			return null;
		}

		return <span>{playlist.name}</span>;
	}
};

export const contentType: IDataTableColumn<FavoritePlaylist, any> = {
	name: "contentType",
	sort: "contentType",
	label: { k: "col.contentType", v: "Content Type" },
	component: playlist => {
		if (!playlist.contentType) {
			return null;
		}

		return <span>{playlist.contentType}</span>;
	}
};

export const actions: IDataTableColumn<FavoritePlaylist, any> = {
	name: "playListactions",
	sort: "playListactions",
	label: { k: "col.playListactions", v: "Actions" },
	component: playlist => (
		<div>
			<Button
				small={true}
				onClick={() => {
					location.href =
						window.location.origin + UrlUtil.getBasePath() +
						"article?articleId=" +
						playlist.articleId;
				}}
			>
				<Icon icon={IconNames.EYE_OPEN} />
			</Button>

			<MutationButton
				variant={ButtonVariant.PRIMARY}
				viewKey="favorite.playlist.delete"
				clazz={FavoritePlaylist}
				params={{ articleId: playlist.articleId }}
				clearCacheOnSuccess={true}
				method={MutationType.DELETE}
			>
				<Icon icon={IconNames.TRASH} />
			</MutationButton>
		</div>
	)
};



// WEBPACK FOOTER //
// ./src/panels/favorites/fragments/FavoritePlaylistFragments.tsx